
  import PeopleIcon from "../../../view-models/PeopleIcon";
  import PeopleInfo from "../../view_elements/PeopleInfo.vue";

  export default {
    components: { PeopleInfo },
    props: { id: String, username: String },
    data() {
      return {
        copied: false
      };
    },
    computed: {
      userIcon(): PeopleIcon {
        return PeopleIcon.newPeopleIconFromCore(
          this.getPeopleByUsername(this.username)
        );
      }
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.id);
      },
      copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        });
      }
    }
  };
